import {Loader} from './Loading.styled'

export const Loading = () => {
  return (
    <Loader />
  )
}
